<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content background-light packages-section">
			<div class="row">
				<div class="flex-row column12">
					<div v-for="item in packagesData" :key="item.ID" class="room-item">
						<nuxt-link :to="localePath(`/${item.filename}`)">
							<picture>
								<source
									v-if="item.overviewImageWebp"
									:srcset="item.overviewImageWebp"
									type="image/webp"
								/>
								<source :srcset="item.overviewImage" />
								<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
							</picture>
						</nuxt-link>
						<div class="room-item-content">
							<div>
								<h3>{{ item.header }}</h3>
								<div v-parse-links v-html="item.overviewContent" />
							</div>
							<nuxt-link :to="localePath(`/${item.filename}`)" class="button button-no-fill">
								{{ $t('buttonView') }}
							</nuxt-link>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: packagesData } = await useWebsiteFetch('packages', {
	query: { language: locale.value },
	key: `${locale.value}/packages`,
});
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 980px;
}

.flex-row {
	display: flex;
	flex-flow: row wrap;
	place-content: flex-start space-between;
}

.room-item {
	width: 31%;
	margin: 0 0 40px;
	padding: 0;
	border-bottom: 1px solid #000;
	text-align: left;
}

.room-item-content {
	padding: 20px 0;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;

	> div {
		max-width: calc(100% - 135px);
	}

	.room-size,
	.button {
		font-size: calc(var(--body-font-size) - 3px);
	}

	.button {
		min-width: 120px;
		padding: 9px 26px;
	}

	h3 {
		font-size: 19px;
		margin: 0 0 5px;
	}
}

@media (max-width: 1080px) {
	.room-item {
		width: 48%;
	}
}

@media (max-width: 680px) {
	.room-item {
		width: 96%;
		margin: 0 2% 40px;
	}
}
</style>
